import { t } from "../i18n/runtime";
import { useState } from "react";
import type { SessionSpeed } from "@cwb/protocol";
import { translateError } from "../i18n";
import { setSessionSpeed } from "../network/api";
import { useGameStore } from "../stores/gameStore";

const SPEED_OPTIONS: ReadonlyArray<{
  speed: SessionSpeed;
  label: string;
  title: string;
}> = [
  {
    speed: 0,
    get label() {
      return t("TimeControls.pause");
    },
    get title() {
      return t("TimeControls.pause_both_the_war_and_the_seven");
    },
  },
  {
    speed: 1,
    label: "x1",
    get title() {
      return t("TimeControls.run_at_normal_speed");
    },
  },
  {
    speed: 2,
    label: "x2",
    get title() {
      return t("TimeControls.run_at_double_speed");
    },
  },
  {
    speed: 4,
    label: "x4",
    get title() {
      return t("TimeControls.run_at_quadruple_speed");
    },
  },
];

/** The selected rate advances both the war and its ranked seven-minute clock. */
export function TimeControls() {
  const sessionId = useGameStore((state) => state.sessionId);
  const connected = useGameStore((state) => state.connected);
  const phase = useGameStore((state) => state.state?.phase);
  const speed = useGameStore((state) => state.simulationSpeed);
  const [pending, setPending] = useState<SessionSpeed | null>(null);

  const choose = async (next: SessionSpeed): Promise<void> => {
    if (!sessionId || pending !== null || next === speed) return;
    setPending(next);
    const result = await setSessionSpeed(sessionId, next);
    setPending(null);
    if (!result.ok) {
      useGameStore.getState().showToast(translateError(result.error), "error");
      return;
    }
    useGameStore.getState().setSimulationSpeed(result.data.speed);
  };

  const disabled = !connected || phase !== "RUNNING";
  return (
    <div
      className="time-controls"
      role="group"
      aria-label={t("TimeControls.game_speed")}
    >
      {SPEED_OPTIONS.map((option) => (
        <button
          type="button"
          className={
            option.speed === speed
              ? "time-control time-control--active"
              : "time-control"
          }
          key={option.speed}
          title={option.title}
          aria-pressed={option.speed === speed}
          disabled={disabled || pending !== null}
          onClick={() => void choose(option.speed)}
        >
          {pending === option.speed ? "…" : option.label}
        </button>
      ))}
    </div>
  );
}
